

export async function fetchCatalogCategoryMaster(api) {
  const { data } = await api.post("/Order/v1.0/getCatalogCategoryMaster", {});
  return data;
}

export async function addMasterCategory(api, categoryName) {
  const { data } = await api.post("/Order/v1.0/AddMasterCategory", {
    categoryName,
  });
  return data;
}
